export const SYSTEM = {
  MARKS: 'marks',
  SKATING: 'skating',
  AJS: 'ajs',
  AJS_FORMATION: 'ajs_formation',
  AJS_SHOWDANCE: 'ajs_showdance',
  AJS_3: 'ajs_3',
  S3_6: 's3-6',
  S_AJS: 's-ajs',
  AJS24: 'ajs24',
  EL_AJS: 'el_ajs'
} as const;

export default SYSTEM;
type t = typeof SYSTEM;
export type SystemType = t[keyof t];
